import Dialog from '@mui/material/Dialog';
import { APIContext } from '../../Contexts/APIContext';
import { useContext, useEffect, useState } from 'react';
import OrgUserTable from './OrgUserTable';
import { UserViewModel } from "./ViewModels/OrganisationVieModel";
import { Button, DialogActions } from '@mui/material';


interface IProps {
    open: boolean;
    onClose: (refresh: boolean) => void;
    siteId: string;
    orgId: string;
}

export default function AddOrgAdminDialog({ open, onClose, siteId, orgId }: IProps) {
    const { get } = useContext(APIContext);
    const [users, setUsers] = useState<UserViewModel[]>([]);

    useEffect(() => {
        getData();
    }, []);

    const getData = () => {
        get("OrganisationSite", `GetSiteUsers?id=${siteId}`, setUsers);
    }

    const checkCloseDialog = async (refresh: boolean) => {
        onClose(refresh);
    }

    return (
        <Dialog
            open={open}
            onClose={() => checkCloseDialog(true)}
            fullWidth
            maxWidth="md"
        >
            <OrgUserTable users={users} title="Site User Details" refresh={getData} orgId={orgId} role="Member" siteId={siteId} />
            <DialogActions>
                <Button onClick={() => checkCloseDialog(true)}>Close</Button>
            </DialogActions>
        </Dialog>
    );
}